import { render, staticRenderFns } from "./SellerProducts.vue?vue&type=template&id=02596cf2&scoped=true"
import script from "./SellerProducts.vue?vue&type=script&lang=js"
export * from "./SellerProducts.vue?vue&type=script&lang=js"
import style0 from "./SellerProducts.vue?vue&type=style&index=0&id=02596cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02596cf2",
  null
  
)

export default component.exports